@if (images !== undefined && images.length > 0) {
  <div class="container">
    <img class="carousel-image slot-a"
         [class.active]="activeSlot === 'a'"
         [class.reset]="resetA"
         [src]="imagePathA" />
    <img class="carousel-image slot-b"
         [class.active]="activeSlot === 'b'"
         [class.reset]="resetB"
         [src]="imagePathB" />
    <div class="datetime-wrapper">
      <div class="date"><span>{{ now | date: 'EEEE, d MMMM' }}</span></div>
      <div class="time"><span>{{ now | date: 'shortTime' }}</span></div>
    </div>
  </div>
}

@if ((images !== undefined && images.length === 0)) {
  <div class="no-images">
    <div>No images to display</div>
    <div>Press back button to exit</div>
  </div>
}
